import React from 'react';

export default function TrustFooter() {
  return (
    <div style={{
      textAlign: 'center', padding: '20px 16px 28px',
      borderTop: '1px solid var(--border)', marginTop: 32,
    }}>
      <div style={{ display: 'flex', justifyContent: 'center', flexWrap: 'wrap', gap: '10px 20px', fontSize: 11, color: 'var(--text-muted)', fontWeight: 600 }}>
        <span>🔒 256-bit Secured</span>
        <span>🏥 Verified Hospitals</span>
        <span>✅ HIPAA Compliant</span>
        <span>💳 Razorpay Protected</span>
      </div>
      <div style={{ marginTop: 10, fontSize: 10, color: 'var(--text-muted)', opacity: 0.7 }}>
        HCEN Healthcare · Trusted by 1,00,000+ patients across India
      </div>
    </div>
  );
}
